import { render, staticRenderFns } from "./Chunk.vue?vue&type=template&id=093c0d70&scoped=true&"
import script from "./Chunk.vue?vue&type=script&lang=js&"
export * from "./Chunk.vue?vue&type=script&lang=js&"
import style0 from "./Chunk.vue?vue&type=style&index=0&id=093c0d70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093c0d70",
  null
  
)

export default component.exports